import _ from "lodash";
import { Coordinate } from "ol/coordinate";

export interface NormalizeResult {
    coord: Coordinate;
    offset: number;
}

export default class CoordHelper {
    static normalizeCoord(input: Coordinate): NormalizeResult {
        const coord = _.cloneDeep(input)
        let offset = 0
        while(coord[0] < -180) {
            coord[0] += 360
            offset += 360
        }
        while(coord[0] > 180) {
            coord[0] -= 360
            offset -= 360
        }
        return {
            coord, offset
        }
    }
}